import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { money } from '../financial/formatting'
import StatusPill from './StatusPill'
import { fmtReceived } from './model'

// The list's rows. A lead row opens its detail (the #id is a real link, so
// it works by keyboard and opens in a new tab). A blocked row never became a
// lead: no id, nothing to open, and its reason is what there is to read.
export default function LeadTable({ rows, timezone }) {
  const navigate = useNavigate()
  return (
    <div className="li-table-scroll">
      <table className="li-table">
        <thead>
          <tr>
            <th scope="col">Lead</th>
            <th scope="col">Received</th>
            <th scope="col">Origin · Sub ID</th>
            <th scope="col">Status</th>
            <th scope="col">Winner / reason</th>
            <th scope="col" className="li-num">Buyers</th>
            <th scope="col" className="li-num">Revenue</th>
            <th scope="col"><span style={srOnly}>Open</span></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => {
            const openable = row.kind === 'lead' && row.lead_id
            const to = openable ? `/lead-inspector/${row.lead_id}` : null
            return (
              <tr
                key={openable ? row.lead_id : `blocked-${i}-${row.received_at}`}
                className={openable ? 'li-row-link' : undefined}
                data-testid={openable ? 'lead-row' : 'blocked-row'}
                onClick={openable ? (e) => { if (!e.target.closest('a')) navigate(to) } : undefined}
              >
                <td style={{ whiteSpace: 'nowrap' }}>
                  {openable ? (
                    <Link to={to} className="li-mono" style={{ color: 'var(--accent)', textDecoration: 'none', fontWeight: 600 }}>
                      #{row.lead_id}
                    </Link>
                  ) : (
                    <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>No lead</span>
                  )}
                  {row.test_mode && <TestTag />}
                </td>
                <td style={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>{fmtReceived(row.received_at, timezone)}</td>
                <td>
                  {row.origin}
                  {row.sub_id && <span style={{ color: 'var(--text-muted)' }}> · <span className="li-mono">{row.sub_id}</span></span>}
                </td>
                <td><StatusPill status={row.status} /></td>
                <td style={{ maxWidth: 280 }}>
                  {row.winner
                    ? <span style={{ fontWeight: 600 }}>{row.winner}</span>
                    : row.reason
                      ? <span style={{ color: 'var(--text-secondary)' }}>{row.reason.label}</span>
                      : <span style={{ color: 'var(--text-muted)' }}>—</span>}
                </td>
                <td className="li-num">{openable ? row.buyers_contacted : '—'}</td>
                <td className="li-num">{row.revenue === null || row.revenue === undefined ? <span style={{ color: 'var(--text-muted)' }}>—</span> : money(row.revenue)}</td>
                <td style={{ width: 28, color: 'var(--text-muted)' }}>
                  {openable && <ChevronRight size={16} aria-hidden="true" />}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

function TestTag() {
  return (
    <span style={{ marginLeft: 6, fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em', padding: '1px 6px', borderRadius: 4, color: 'var(--amber)', background: 'var(--amber-bg)' }}>
      Test
    </span>
  )
}

const srOnly = { position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', border: 0 }
